export const supportsServerIpOverride = ({ app, auth } = {}) => {
  return auth?.type === 'custom' && !!auth?.action?.actionId && app?.api?.length === 1 && app.api[0]?.type === 'rest';
};
